import React from 'react';
import PropTypes from 'prop-types';

/**
 * PageEllipsis - A wrapper that renders a standard HTML span with Bulma class names
 *
 * This component accepts the same props as Bloomer PageEllipsis for easy migration
 */
const PageEllipsis = ({ className, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['pagination-ellipsis'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <span className={getClassNames()} style={style} {...props}>
      &hellip;
    </span>
  );
};

PageEllipsis.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

PageEllipsis.defaultProps = {
  className: '',
  style: {},
};

export default PageEllipsis;
